"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var Icon;
(function (Icon) {
    Icon["Globe"] = "globe";
    Icon["Mountain"] = "mountain";
    Icon["Gear"] = "gear";
    Icon["User"] = "user";
    Icon["Glip"] = "flip";
    Icon["GearUser"] = "gear-user";
    Icon["Heart"] = "heart";
    Icon["Jobs"] = "jobs";
    Icon["Phone"] = "phone";
    Icon["Mail"] = "mail";
    Icon["Fb"] = "fb";
    Icon["In"] = "in";
    Icon["Insta"] = "insta";
    Icon["Facebook"] = "facebook";
    Icon["LinkedIn"] = "linked-in";
    Icon["Instagram"] = "instagram";
    Icon["ArrowLeft"] = "arrow-left";
    Icon["ArrowRight"] = "arrow-right";
    Icon["ArrowDown"] = "arrow-down";
    Icon["ArrowUp"] = "arrow-up";
})(Icon = exports.Icon || (exports.Icon = {}));
